import noop from 'lodash/noop';
import { createContext, useContext } from 'react';
import type { PropsWithChildren } from 'react';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import useAppShellState, {
  AppShellActions,
  AppShellState,
} from '@/data/hook/app-shell/useAppShellState';

const AppShellContext = createContext<AppShellState | null>(null);

const AppShellActionsContext = createContext<AppShellActions>({
  setBackTarget: noop,
  setBreadcrumbsTarget: noop,
  getPreviousPath: () => undefined,
});

export function AppShellProvider({ children }: PropsWithChildren) {
  const { state, actions } = useAppShellState();

  return (
    <ConditionalRenderer condition={state}>
      <AppShellActionsContext.Provider value={actions}>
        <AppShellContext.Provider value={state}>
          {children}
        </AppShellContext.Provider>
      </AppShellActionsContext.Provider>
    </ConditionalRenderer>
  );
}

export function useAppShellActions() {
  return useContext(AppShellActionsContext);
}

export function useAppShell() {
  const context = useContext(AppShellContext);
  if (!context) {
    throw new Error('useAppShell must be used within an AppShellProvider');
  }
  return context;
}
